import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';
import { Form, Card, CardBody } from 'reactstrap';
import { friendlyErrorMessage } from 'app/utils/parsers';
import Alert from 'app/components/general/Alert';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import StepNumberDivider from 'app/components/general/StepNumberDivider';
import IActions from 'app/types/actions';
import sports from 'app/utils/static/sports';
import OrganisationIcon from 'app/images/icons/organisation.svg';
import SportIcon from 'app/images/icons/sport.svg';

interface ISportsOrgDetailsProps {
  actions: IActions;
  connect: any;
  currentOrganisation: any;
  authentication: any;
  match: any;
  organisation?: {
    organisationId: string;
    selectedSport: string;
    organisationName: string;
  };
  sports: any;
}

interface ISportsOrgDetailsState {
  name?: string;
  sport?: {
    label: string;
    value: string;
  };
  organisation?: string;
  errors: any;
}

export default class SportsOrgDetails extends React.Component<
  ISportsOrgDetailsProps,
  ISportsOrgDetailsState
> {
  static defaultProps = {
    match: undefined,
    sports: [],
    actions: undefined,
  };

  state: ISportsOrgDetailsState = {
    name: this.props.connect?.prefilledInformation?.organisationName || this.props.organisation.organisationName || '',
    sport:
      this.props.connect?.prefilledInformation?.sport || (_.isEmpty(this.props.organisation)
      || _.isEmpty(this.props.organisation.selectedSport)
      ? { id: 'Basketball', name: 'Basketball' }
      : this.props.organisation.selectedSport),
    organisation: this.props.organisation.organisationId || '',
    errors: [],
  };

  componentDidMount(): void {
    if (this.props.actions.getSports) {
      this.props.actions.getSports();
    }
    if (this.props.actions.resetOnboarding) {
      this.props.actions.resetOnboarding();
    }
  }

  handleChange = (e): void => {
    delete this.state.errors[e.target.name];

    const state = {
      [e.target.name]: e.target.value,
      errors: this.state.errors,
    };
    this.setState(state);
  };

  handleAssociationChange = (e): void => {
    delete this.state.errors.organisation;
    if (e && e.value != null) {
      this.setState({ organisation: e.value });
    }
    if (e == null) {
      this.setState({ organisation: '' });
    }
  };

  handleSportChange = (e): void => {
    delete this.state.errors.sport;
    if (e && e.id !== null) {
      this.setState({ sport: e });
    }
  };

  handleSubmit = (e): void => {
    e.preventDefault();

    this.props.actions.updateAdminData({
      organisation: {
        organisationName: this.state.name,
        selectedSport: this.state.sport.id,
        organisationId: this.state.organisation,
      },
    });
    if (!_.isEmpty(this.props.match?.params?.provider)) {
      history.push(`/get-started/personal/connect/${this.props.match?.params?.provider}`);
    } else {
      history.push(`${this.props.match.url}/personal`);
    }
  };

  renderBackendErrors(): React.ReactNode {
    if (
      !_.isEmpty(this.state.backendErrors?.message)
    ) {
      return (
        <Alert color="error">
          {friendlyErrorMessage(this.state.backendErrors.message)}
        </Alert>
      );
    }
    return null;
  }

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <Card className="extra-shadow">
              <CardBody className="with-extra-padding-2">

                <div className="row">
                  <div className="col">
                    <h2>
                      Tell us about your organisation
                    </h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col with-padding">
                    <StepNumberDivider number={1} total={3} />

                    <Form onSubmit={this.handleSubmit}>
                      <InputGroupBlock
                        type="text"
                        icon={OrganisationIcon}
                        labelText="Organisation name"
                        placeholder="Organisation name"
                        aria-label="Organisation name"
                        inputGroupClassName="large"
                        autoFocus
                        autoComplete="off"
                        tabIndex="1"
                        name="name"
                        value={this.state.name}
                        onChange={this.handleChange}
                      />
                      <InputGroupBlock
                        type="select"
                        icon={SportIcon}
                        className="height-50"
                        labelText="What sport?"
                        name="sport"
                        inputGroupClassName="large"
                        placeholder="Sport"
                        aria-label="Sport"
                        autoComplete="off"
                        tabIndex="2"
                        value={this.state.sport}
                        options={sports}
                        onChange={this.handleSportChange}
                      />

                      <Button
                        className="btn-1 btn-full-width success-sm d-flex d-sm-none large"
                        color="primary"
                        tabIndex="3"
                        disabled={!this.state.sport || !this.state.name}
                        type="submit"
                      >
                        Continue
                      </Button>
                      <Button
                        className="btn-1 btn-full-width success-sm d-none d-sm-flex large"
                        color="primary"
                        tabIndex="4"
                        disabled={!this.state.sport || !this.state.name}
                        type="submit"
                      >
                        Continue to personal details
                      </Button>
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="with-margin-top-30 text-center text-grey">
              Already have an account?&nbsp;
              <Link to="/login">Log in</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
